// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3wnXc","info":"Note_info__kD4go","note":"Note_note__38CGj","actions":"Note_actions__28NYD"};